export default __webpack_public_path__ + "static/cloud-1-43c466c7eeb243a84659edce0c3afd77.jpeg";